<template>
  <el-dialog
    :visible.sync="showDialog"
    :width="modalWidth"
    top="25vh"
    :before-close="handleClose"
    :show-close="false"
  >
    <main class="flex flex-col items-center relative">
      <span @click="handleClose" class="cursor-pointer absolute -top-4 right-0">
        <close-icon size="h-5 w-5" />
      </span>
      <h3 class="text-lg text-black-10 font-semibold">Enter Amount</h3>
      <p class="text-center text-xs my-5 lg:text-sm font-normal text-gray-25">
        Enter the amount you want this beneficiary to receive.
      </p>

      <div
        class="w-full flex items-center border gap-4 border-gray-120 rounded-lg p-4"
      >
        <div
          class="h-12 w-12 flex items-center justify-center rounded-full bg-secondary-2 text-primary uppercase font-bold text-base"
        >
          {{ getNameInitials(details.details.bankDetails.accountName) }}
        </div>
        <div class="flex flex-col items-start">
          <h5
            class="font-bold text-left text-black-10 text-base sm:text-lg capitalize"
          >
            {{ formatAccountName(details.details.bankDetails.accountName) }}
          </h5>
          <p
            class="text-black-10 flex gap-2 text-xs sm:text-sm font-normal mt-1 capitalize"
          >
            <span class="text-gray-muted">Bank:</span>
            {{ details.details.bankDetails.bankName || '--' }}
          </p>
          <p
            class="text-black-10 flex gap-2 text-xs sm:text-sm font-normal mt-1 capitalize"
          >
            <span class="text-gray-muted">Account Number:</span>
            {{ details.details.bankDetails.accountNumber || '--' }}
          </p>
        </div>
      </div>

      <el-form
        label-position="top"
        :model="form"
        ref="form"
        :rules="rules"
        @submit.native.prevent="validateForm('form')"
        @keyup.enter.native="validateForm('form')"
        class="w-full mt-3"
      >
        <el-form-item label="Enter Amount" prop="amount">
          <el-input
            v-model.trim="form.amount"
            class="border rounded-md text-base text-black-10"
            :class="formattedCurrency === $CURRENCY.CFA && 'pl-5'"
          >
            <i
              slot="prefix"
              class="font-normal text-black-10 h-full inline-flex items-center not-italic pl-2"
            >
              {{ formattedCurrency }}
            </i>
          </el-input>
        </el-form-item>

        <button
          type="submit"
          class="text-white bg-primary w-full py-4 text-sm font-normal rounded-lg mt-3"
        >
          Done
        </button>
      </el-form>
    </main>
  </el-dialog>
</template>

<script>
import breakpoints from '@/utils/breakpoints.js'
import bulkPayout from '@/mixins/bulkPayout.js'
import { ParseAmount } from '@/utils/helpers.js'
import provider from '@/mixins/provider.js'
export default {
  name: 'EnterAmount',
  mixins: [bulkPayout, provider],
  props: {
    showDialog: {
      type: Boolean,
      default: false
    },
    details: {
      type: Object,
      default: () => {}
    }
  },
  components: {
    CloseIcon: () => import('@/assets/v2/icons/CloseIcon')
  },
  data () {
    return {
      breakpoints,
      form: {
        amount: ''
      },
      rules: {
        amount: [
          {
            required: true,
            message: 'Kindly enter an amount',
            trigger: ['blur', 'change']
          }
        ]
      }
    }
  },
  computed: {
    modalWidth () {
      return breakpoints.lgAndUp ? '30%' : breakpoints.mdAndUp ? '70%' : '85%'
    },
    selectedBeneficiaries () {
      return this.$store.state.bulkPayout.selectedBeneficiaries || []
    },
    payoutMethod () {
      return this.$store.state.bulkPayout.bulkPayoutForm.paymentMethod
    },
    payoutCurrency () {
      return this.$store.state.bulkPayout.bulkPayoutForm.currency
    }
  },
  methods: {
    handleClose () {
      this.$emit('closeDialog')
    },
    validateForm (form) {
      this.$refs[form].validate((valid) => {
        if (valid) {
          this.addAmount()
        } else {
          this.$notify.error({
            title: 'Invalid input',
            message: 'Please fill the input correctly',
            position: 'top-right'
          })
        }
      })
    },
    addAmount () {
      const formattedAmount = this.form.amount.replaceAll(',', '')
      const allDetails = {
        ...this.details,
        amount: parseFloat(formattedAmount)
      }
      const itemAlreadySaved = this.selectedBeneficiaries.find(
        (beneficiary) => beneficiary.id === this.details.id
      )

      if (!itemAlreadySaved) {
        this.$store.dispatch('bulkPayout/setSelectedBeneficiaries', allDetails)
      }
      this.handleClose()
    }
  },
  watch: {
    'form.amount': function (newValue) {
      let pattern = /[^\d.]/g
      if (this.isHub2Provider) {
        // if payout partner is hub2, prevent decimal input
        pattern = /[^\d]/g
      }
      const result = newValue.replace(pattern, '')
      this.$nextTick(() => {
        this.form.amount = ParseAmount(result)
      })
    }
  },
  beforeMount () {
    this.handleHub2ProviderPayout({
      payoutMethod: this.payoutMethod,
      currency: this.payoutCurrency
    })
  }
}
</script>

<style scoped>
>>> .el-dialog {
  border-radius: 8px !important;
}
>>> .el-dialog__body {
  padding: 0 20px 20px 20px;
}
>>> .el-input--prefix .el-input__inner {
  color: #171717;
  border: 0;
}
</style>
